var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "active_a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440 0v821H0V0h1440Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "active_b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.917 0a4 4 0 0 1 3.723 2.537L16.214 4H21a1 1 0 0 1 0 2h-.235l-1.462 12.466A4 4 0 0 1 15.331 22H7.669a4 4 0 0 1-3.972-3.534L2.234 6H1a1 1 0 1 1 0-2h5.785l.575-1.463A4 4 0 0 1 11.083 0h.834Zm6.834 6H4.248l1.435 12.233a2 2 0 0 0 1.828 1.76l.158.007h7.662a2 2 0 0 0 1.961-1.61l.025-.157L18.751 6Zm-6.834-4h-.834a2 2 0 0 0-1.795 1.12l-.066.149L8.934 4h5.131l-.287-.731a2 2 0 0 0-1.698-1.262L11.917 2Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#active_a)",
    transform: "translate(-709 -765)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#active_b)",
    transform: "translate(709 765)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CFB170",
    d: "M0 0h22v22H0V0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/Trash.f096e43aaa307e8895b7da92a5bd7808.svg";
export { ForwardRef as ReactComponent };